export const isSubstring = (a?: string, b?: string): boolean => {
  if (!a || !b) return false;
  return a.toLowerCase().includes(b.toLowerCase());
};
